/* eslint-disable func-style */
import React, { useState, useMemo } from 'react';
import { Table, Grid, Header } from 'semantic-ui-react';
import { getEndOfMonth } from './utils.js';

function HeaderRow() {
  return (
    <Table.Header>
      <Table.Row textAlign='right'>
        <Table.HeaderCell>SUN</Table.HeaderCell>
        <Table.HeaderCell>MON</Table.HeaderCell>
        <Table.HeaderCell>TUE</Table.HeaderCell>
        <Table.HeaderCell>WED</Table.HeaderCell>
        <Table.HeaderCell>THU</Table.HeaderCell>
        <Table.HeaderCell>FRI</Table.HeaderCell>
        <Table.HeaderCell>SAT</Table.HeaderCell>
      </Table.Row>
    </Table.Header>
  );
}

export default function MonthViewCalendar({
  selectedDate,
  footerContent,
  getDateActivities,
}) {
  const endOfMonth = getEndOfMonth(selectedDate).getDate();
  const [CalendarHeader] = useState(() => HeaderRow);
  const footer = useMemo(
    () =>
      footerContent && (
        <Table.Footer fullWidth>
          <Table.Row>
            <Table.HeaderCell
              colSpan='7'
              textAlign='center'
            >
              {footerContent}
            </Table.HeaderCell>
          </Table.Row>
        </Table.Footer>
      ),
    [footerContent],
  );

  const renderDateContent = (date) => {
    return (
      <Grid padded>
        <Grid.Row>
          <Grid.Column
            floated='left'
            width={5}
          />
          <Grid.Column
            floated='right'
            width={5}
          >
            <Header
              size='medium'
              style={{ fontWeight: 'normal' }}
            >
              {date}
            </Header>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <div>{getDateActivities(date)}</div>
        </Grid.Row>
      </Grid>
    );
  };

  const renderWeek = (weekIdx) => {
    const days = [];
    const startOfWeek = weekIdx * 7 + 1 - selectedDate.getDay();
    const endOfWeek = startOfWeek + 6;

    for (let date = startOfWeek; date <= endOfWeek; date += 1) {
      days.push(
        <Table.Cell key={date}>
          {date > 0 && date <= endOfMonth && renderDateContent(date)}
        </Table.Cell>,
      );
    }
    return <Table.Row key={startOfWeek}>{days}</Table.Row>;
  };

  const renderWeeks = () => {
    const weeks = [];

    for (let weekIndex = 0; weekIndex < 6; weekIndex += 1) {
      weeks.push(renderWeek(weekIndex));
    }

    return <Table.Body>{weeks}</Table.Body>;
  };

  return (
    <Table
      celled
      columns={7}
    >
      <CalendarHeader />

      {renderWeeks()}
      {footer}
    </Table>
  );
}
